import { lazy, type ReactNode, Suspense } from "react";
import { useLazyVisible } from "@/common/hooks/useLazyVisible";
import Banner from "@/widgets/HomePage/Banner";
import SeoText from "@/widgets/HomePage/SeoText";

const Benefits = lazy(() => import("@/widgets/HomePage/Benefits"));
const GetMoneySteps = lazy(() => import("@/widgets/GetMoneySteps"));
const Advantages = lazy(() => import("@/widgets/HomePage/Advantages"));
const ActionCall = lazy(() => import("@/widgets/HomePage/ActionCall"));

const LazySection = ({ children }: { children: ReactNode }) => {
  const { ref, isVisible } = useLazyVisible<HTMLDivElement>();

  return (
    <div ref={ref}>
      {isVisible && <Suspense fallback={null}>{children}</Suspense>}
    </div>
  );
};

export const HomePage = () => {
  return (
    <div className="home-page">
      <Banner />
      <LazySection>
        <Benefits />
      </LazySection>
      <LazySection>
        <GetMoneySteps />
      </LazySection>
      <LazySection>
        <Advantages />
      </LazySection>
      <LazySection>
        <ActionCall />
      </LazySection>
      <SeoText />
    </div>
  );
};
